@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

@keyframes generating {
  0% {
    background-color: var(--toast-neutral-background-color);
  }

  16% {
    background: var(--blaze-baby-blue);
  }

  32% {
    background: var(--blaze-joker-green);
  }

  48% {
    background: var(--blaze-bright-yellow);
  }

  64% {
    background: var(--blaze-orange);
  }

  80% {
    background: var(--blaze-pink);
  }
}

.messageContainer {
  @include transition;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  overflow: hidden;
  width: fit-content;
  box-shadow: 0px 8px 22px 0px rgba(0, 0, 0, 0.14);
  padding: 10px;
  gap: 10px;
  background: var(--toast-neutral-background-color);
  @include blur(35px);

  @include for-phone-only {
    &:not(.rating):not(.designRating) {
      padding: 15px;

      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      box-shadow: 0px -1px 22px 0px rgba(0, 0, 0, 0.15);
      height: 70px;
      border-radius: 0;
      width: 100%;
    }
  }

  color: var(--dark-80);

  &.isRightRailOpen {
    margin-right: var(--right-rail-content-width);
  }

  &.adjustedPadding {
    padding: 4px 12px;
  }

  .details {
    display: flex;
    gap: 5px;
  }

  .action:empty {
    display: none;
  }

  .contentContainer {
    @include md-sohne-medium;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0 8px 8px 0;

    .content {
      max-width: 408px;
      text-align: left;

      &.wide {
        max-width: 580px;
      }

      &.clamped {
        @include line-clamp(2);
      }
    }
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: stretch;

    &.generating {
      margin-right: 4px;
      > * {
        > *:after {
          background: var(--toast-neutral-background-color);
          animation: generating 6s infinite;
        }
      }
    }
  }

  &.info {
    .icon {
      padding-right: 0;
    }
  }

  &.generating {
    animation: generating 6s infinite;
  }

  &.success {
    background: var(--default-bg);

    &[data-theme='dark'] {
      background: rgba(0, 0, 0, 0.9);
      color: white;

      .contentContainer {
        font-weight: 400;
      }

      .icon {
        color: white;
      }
    }
  }

  &.error {
    background: var(--red-70);

    .action {
      button {
        color: var(--light-100);
      }
    }

    .content {
      color: var(--light-100);
    }

    .icon {
      color: var(--light-100);
    }
  }

  &.pink {
    background: linear-gradient(0deg, #e8099c 0%, #f9f 100%);
    box-shadow: 0px 8px 37px 0px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(25px);

    .content,
    .icon {
      color: var(--light-100);
    }
  }

  &.rating,
  &.designRating,
  &.generatingSocialCta {
    background: var(--light-80);
    padding: 6px 6px 6px 11px;
    gap: 15px;
  }

  &.singleLine {
    background: var(--light-80);
    padding: 10px;
    gap: 10px;
  }
}

:global(.blaze-toast-container):has(.designRating) {
  @include for-phone-only {
    top: 56px;
    bottom: auto;
  }
}

:global(.blaze-toast-container):has(.generatingSocialCta) {
  bottom: 10px;
}
